var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 0H1.875C1.35722 0 0.9375 0.419719 0.9375 0.9375V9.3892C0.9375 16.0136 5.4203 21.6253 11.6744 23.9416C11.8845 24.0195 12.1155 24.0195 12.3256 23.9416C18.5897 21.6216 23.0625 16.0039 23.0625 9.3892V0.9375C23.0625 0.429328 22.6469 0 22.125 0ZM2.8125 9.3892V1.875H12.8883C9.78094 8.69995 3.9832 10.6542 2.97413 11.3971C2.86702 10.7359 2.8125 10.0652 2.8125 9.3892ZM3.4327 13.2863C4.63786 12.3893 11.6064 10.0957 14.9288 1.875H20.8896C17.2654 13.764 7.272 17.35 6.27572 18.1418C4.93233 16.6573 3.99056 14.9987 3.4327 13.2863ZM21.1875 9.3892C21.1875 15.0368 17.4188 19.9207 12 22.0589C10.4005 21.4277 8.94694 20.5641 7.68745 19.5035C8.61014 18.8129 16.6068 15.8062 21.1875 6.26175V9.3892Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.f109a0ee.svg";
export { ForwardRef as ReactComponent };